import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import Img from 'gatsby-image'

const Wrapper = styled.a`
  width: 100%;
  ${tw`shadow-lg relative no-underline rounded-lg px-2 py-2 md:py-18 text-white`};
  background: ${props => props.bg};
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  &:hover {
    transform: translateY(-5px);
  }
`

const ItemContent = styled.div`
  ${tw`py-8 px-6 flex flex-wrap content-between relative`};
`

const Bottom = styled.div`
  ${tw`z-30 flex flex-col px-2`};
`

const Text = styled.div`
  ${tw`opacity-75 text-left font-sans text-sm md:text-base z-30`};
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
`

const Title = styled.div`
  ${tw`text-white text-left uppercase text-lg md:text-xl lg:text-2xl tracking-wide font-sans pt-4 z-30`};
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
`

const BGImage = styled.div`
  ${tw`absolute pin rounded-lg min-h-150`};
  .gatsby-image-outer-wrapper {
    position: static !important;
  }
  .gatsby-image-wrapper {
    position: static !important;
  }
  img {
    ${tw`rounded-lg`};
    opacity: 1 !important;
  }
`

const Tools = styled.div`
  ${tw`flex flex-wrap pt-2`};
`

const Tool = styled.div`
  ${tw`text-xs p-1 mt-1 px-3 mr-2 font-sans rounded-full`};
  background-color: #9561E2;
`

const ProjectCard = ({ title, link, bg, thumb, description, tools }) => (
  <Wrapper href={link} target="_blank" rel="noopener noreferrer" bg={bg}>
    <ItemContent>
      <BGImage>
        <Img fluid={thumb} />
      </BGImage>
    </ItemContent>
    <Bottom>
      <Title>{title}</Title>
      <Text>{description}</Text>
      <Tools>
        {tools.map(tool => (
          <Tool>{tool}</Tool>
        ))}
      </Tools>
    </Bottom>
  </Wrapper>
)

export default ProjectCard

ProjectCard.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  bg: PropTypes.string.isRequired
}